import { NgModule } from '@angular/core';
import {SocialShareComponent} from "./social-share.component";
import {CommonModule} from "@angular/common";
import {HttpModule} from "@angular/http";

@NgModule({
  declarations: [
    SocialShareComponent
  ],
  exports: [
    SocialShareComponent
  ],
  providers: [],
  imports: [
    CommonModule,
    HttpModule
  ]
})
export class SocialShareModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/social-share/social-share.module.ts